import React, { useEffect, useState, useRef, useCallback } from 'react';
import "./landing-page.less";
import "./landing-page-mobile.less";
import CheckmarkGreen from '../../../assets/checkmark-green.svg';
import TriangleExclamation from '../../../assets/triangle-exclamation-orange.svg';
import ProButton from '../../shared/pro-button/pro-button';
import { TFunction, Trans, useTranslation } from 'react-i18next';
import { getCandidateExamInfo, candidateExamInfo, checkFreezeState } from './landing-page-helper';
import { getDownloadUserGuideUrl } from '../../util/util';
import SystemCheck from '../system-check/system-check';
import Main from '../main/main';
import OutageBanner from '../../shared/outage-banner/outage-banner';
import { Modal } from 'antd';
import InfoIcon from '../../../assets/circle-info-solid.svg';
import VideoSection from '../video-section/video-section';
import { deviceCheck } from '../system-check/util/device-check';
import { useAppContext } from '../../../hooks/use-app-context';
import { useInterval } from '../../../hooks/use-interval';
import { useNavigate } from 'react-router-dom';
import { Locations } from '../../../lib/locations';

const KNOWLEDGE_BASE_URL = process.env.REACT_APP_KNOWLEDGE_BASE_URL as string;
const ENVIRONMENT_NAME = process.env.REACT_APP_ENVIRONMENT_NAME;
const DEFAULT_FREEZE_POLL_INTERVAL_SECONDS = 30;
const freezePollIntervalSeconds = Number(process.env.REACT_APP_FREEZE_POLL_INTERVAL_SECONDS);
const FREEZE_POLL_INTERVAL_MS =
  (Number.isFinite(freezePollIntervalSeconds) && freezePollIntervalSeconds > 0
    ? freezePollIntervalSeconds
    : DEFAULT_FREEZE_POLL_INTERVAL_SECONDS) * 1000;

function LandingPage() {
    const { candidateInfo: candidateInfoCtx, setCandidateInfo: setCandidateInfoCtx } = useAppContext();
    const systemCheckRef = useRef(null);
    const navigate = useNavigate();
    const [findExam, setfindExam] = useState(false);
    const [candidateInfo, setcandidateInfo] = useState(candidateExamInfo)
    const { t, i18n } = useTranslation();
    const [showSystemCheck, setShowSystemCheck] = useState(false);
    const [lastName, setLastName] = useState('');
    const [confNumber, setConfNumber] = useState('')
    const [displayError, setDisplayError] = useState(false);
    const [displayNetworkError, setDisplayNetworkError] = useState(false);
    const [onLine, setOnline] = useState(true);
    const [isEu, setIsEu] = useState(false);
    const [systemCheckStatus, setSystemCheckStatus] = useState('');
    const [systemCheckStart, setSysCheckStart] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [formFieldAriaDescribedBy, setFormFieldAriaDescribedBy] = useState(''); // Initial value
    const [isFreezeActive, setIsFreezeActive] = useState(false);

    const confirmationNumberRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
      if (candidateInfoCtx) {
        setcandidateInfo(candidateInfoCtx);
        setfindExam(true);
      }
    }, [candidateInfoCtx]);

    const pollFreezeState = useCallback(() => {
      checkFreezeState(confNumber, lastName)
        .then((isFrozen) => setIsFreezeActive(isFrozen))
        .catch(() => {});
    }, [confNumber, lastName]);

    const { start: startFreezePolling } = useInterval(pollFreezeState, FREEZE_POLL_INTERVAL_MS);

    useEffect(() => {
      if (process.env.REACT_APP_FREEZE_CHECK_ENABLED !== 'true') return;
      pollFreezeState();
      startFreezePolling();
    }, [pollFreezeState, startFreezePolling]);

    useEffect(() => {
      if (isFreezeActive && showSystemCheck) {
        setShowSystemCheck(false);
      }
    }, [isFreezeActive, showSystemCheck]);

    useEffect(() => {
        setIsEu(ENVIRONMENT_NAME === "neuprod");
        displaySystemCheckResults(systemCheckStatus, systemCheckStart);
        handleChange({
            target: {
                type: '',
                value: undefined
            }
        });
    }, [i18n.language]);

    useEffect(() => {
        if (displayError && confirmationNumberRef.current) {
            confirmationNumberRef.current.focus();
        }
    }, [displayError]);


    const modalSysCheckTitles = 
    <div className='landing-page-modal-title'>
          <i className="fa-solid fa-triangle-exclamation fa-xl icon-warning"></i>
          <h3 className='modal-system-warning-message'>{t('LANDING_PAGE_SYS_CHECK_ON_SMART_PHONE_ERROR')}</h3>
    </div>



    const showSmartphoneCheckModal = () => {
      setIsModalVisible(true);
    };
  
    const handleSmartphoneCheckModalOk = () => {
      setIsModalVisible(false);
    };
  
    const handleSmartphoneCheckModalCancel = () => {
      setIsModalVisible(false);
    };
  
    window.addEventListener("offline", (e) => {
        setOnline(false);
    });
      
    window.addEventListener("online", (e) => {
        setOnline(true);
    });

   
    const handleChange =(event: { target: {[x: string]: any; type: string; value: any; }; }) => {
        if(!document.getElementById('confirmation-number') || !document.getElementById('lname')){
            return;
        }

        setFormFieldAriaDescribedBy("");
        setDisplayError(false);
        document.getElementById('confirmation-number')!.style.borderColor = "#FFFFFF";
        document.getElementById('lname')!.style.borderColor = "#FFFFFF";

        if(event.target.id === 'confirmation-number') {
            setConfNumber(event.target.value)
        }else{
            setLastName(event.target.value);
        }
    }

    const handleCancel = (event: any)=>{
        setDisplayNetworkError(false)
    }
    
    const handleError =(error: any)=>{     
        if(JSON.stringify(error).includes('Network Error')){
            setDisplayNetworkError(true);
            return;
        }
 
        document.getElementById('confirmation-number')!.style.borderColor = "red";
        document.getElementById('lname')!.style.borderColor = "red";
        setFormFieldAriaDescribedBy('landing-page-exam-not-found');
        setDisplayError(true);
        
    }

    const  handleSubmit = async (_event: { preventDefault: () => void; })=> {
        if(!onLine){
            setDisplayNetworkError(true);
            return;
        }else{
            setDisplayNetworkError(false);
        }
        setDisplayError(false);
        try{
           if (process.env.REACT_APP_FREEZE_CHECK_ENABLED === 'true') {
               const frozen = await checkFreezeState(confNumber, lastName);
               if (frozen) {
                   setIsFreezeActive(true);
                   return;
               }
           }
           let candidateExamInfo =  await getCandidateExamInfo(confNumber, lastName, i18n.language);
           setCandidateInfoCtx(candidateExamInfo);
        }catch(error){
            handleError(error);
        }
    }

    const displaySystemCheckResults = (systemCheckStatus: string, systemCheckStart: boolean) => {
        setSysCheckStart(systemCheckStart);
        setSystemCheckStatus(systemCheckStatus); 
        const PASSED = "Passed";
        const paraSuccess = document.getElementById('landing-page-system-check-result');
        const paraError = document.getElementById('landing-page-system-check-result-error');
        const image = document.createElement("img");
        image.ariaHidden = "true";
        const systemCheckSuccess = t('LANDING_PAGE_SYSTEM_CHECK_SUCCESS')
        const systemCheckError = t('LANDING_PAGE_SYSTEM_CHECK_ERROR')
        const element = document.getElementById('landing-page-sys-check-result');

        if(!systemCheckStart){
            if (element) {
                const imagChild = element.children[2] 
               if(imagChild){
                element.removeChild(imagChild);
               } 
            } 
            if(paraSuccess){
                paraSuccess.innerText = '';
            }
            if(paraError){
                paraError.innerText = '';
            }
            return;
        }
       
       if(PASSED.toUpperCase() === systemCheckStatus.toUpperCase()){
            image.src = CheckmarkGreen;
            if(paraSuccess){
                paraSuccess.innerText = systemCheckSuccess
            }
            if(paraError){
                paraError.innerText = '';
            }
            if (element) {
                const imagChild = element.children[2] 
               if(imagChild){
                element.removeChild(imagChild);
               }    
                element.appendChild(image);
            }
       }else{
            image.src = TriangleExclamation;
            if(paraSuccess)
            {
                paraSuccess.innerText = '';
            }
            if(paraError)
            {
                paraError.innerText = systemCheckSuccess
            }
            if (element) 
            {
                const imagChild = element.children[2] 
                if(imagChild)
                {
                    element.removeChild(imagChild);
                }    
                if(paraError)
                {
                    paraError.innerText = systemCheckError;
                }
                element.appendChild(image);
            } 
       }
    }

    return (
        findExam? <Main examSession ={candidateInfo} isFreezeActive={isFreezeActive}></Main>:
        <main className='landing-page-main'>
            {isFreezeActive && <OutageBanner />}
            <section id='landing-page-find-exam'>
                <h2 className='landing-page-text-label-h2'>{t('LANDING_PAGE_START_PREPARING')}</h2>
                <div className='landing-page-find-exam'>{t('LANDING_PAGE_FIND_YOUR_EXAM')}</div>
                <form className="form-inline" >
                    <div className='landing-page-conf-number'>
                        <label className='landing-page-form-label' htmlFor="confirmation-number">{t('LANDING_PAGE_CONFIRMATION_NUMBER')}:</label><br />
                        {displayError?<i className="fa-solid fa-triangle-exclamation icon-confirmation"></i>: ''}
                        <input 
                            type="text" 
                            id="confirmation-number" 
                            name="confirmation-number" 
                            max='' 
                            value={confNumber} 
                            onChange={handleChange}
                            ref={confirmationNumberRef}
                            aria-describedby={formFieldAriaDescribedBy} 
                            aria-invalid={displayError ? 'true' : 'false'}
                        />
                    </div>
                    <div className='landing-page-last-name'>
                        <label className='landing-page-form-label' htmlFor="lname">{t('LANDING_PAGE_LAST_NAME')}:</label> <br/>
                        {displayError?<i className="fa-solid fa-triangle-exclamation icon-lname"></i>: ''}
                        <input 
                            type="text" 
                            id="lname" 
                            name="lname"  
                            value={lastName} 
                            onChange={handleChange} 
                            aria-describedby={formFieldAriaDescribedBy} 
                            aria-invalid={displayError ? 'true' : 'false'}
                            />
                    </div>
                    <div className='landing-page-button'>
                        <div className='main-button-group'>
                        <ProButton
                                text={t('LANDING_PAGE_FIND_EXAM')}
                                colorscheme="secondary"
                                size="medium"
                                icon="fa-solid fa-magnifying-glass"
                                iconType="fa-solid"
                                classname="landing-page-sys-check"
                                iconPosition="left"
                                download="none"
                                downloadUrl="#"
                                onClick={(event) => {
                                event.preventDefault();
                                handleSubmit(event);
                            }}
                        />
                        </div>
                    </div>   
                    <div className='landing-page-exam-not-found'>
                        {displayError?<p id='landing-page-exam-not-found'> {t('LANDING_PAGE_EXAM_NOT_FOUND')}</p> : ''}
                    </div>
                </form>
            </section>
            <Modal
                title={modalSysCheckTitles}
                open={isModalVisible} 
                onOk={handleSmartphoneCheckModalOk}       
                onCancel={handleSmartphoneCheckModalCancel}
                className='modal-device-error'
                footer={[
                    <ProButton
                        text={t('LANDING_PAGE_CLOSE')}
                        colorscheme="none"
                        size="medium"
                        icon=""
                        iconType=""
                        classname="smartphone-modal-close"
                        iconPosition="left"
                        download="doc"
                        downloadUrl="#"
                        onClick={(event) => {
                            event.preventDefault();
                            handleSmartphoneCheckModalCancel();
                        }}
                    />,
                  ]}
                >
                <p className='system-check-error-on-smartphone-first-para'>{t('LANDING_PAGE_SYS_CHECK_ON_SMART_PHONE_ERROR_FIRST_PARA')}</p> 
                <p>{t('LANDING_PAGE_SYS_CHECK_ON_SMART_PHONE_ERROR_SECOND_PARA')}</p> 
               
            </Modal>
       
            {displayNetworkError? renderNetworkError(t, handleSubmit, handleCancel): ''}
            {renderNotScheduled(isEu, t, setShowSystemCheck, setIsModalVisible, systemCheckRef, i18n.language, isFreezeActive, navigate)}
          
            {showSystemCheck && <SystemCheck show={showSystemCheck} close={() => setShowSystemCheck(false)} displaySystemCheckResults ={displaySystemCheckResults} />}
        </main>
    );
}

const isDeviceEligible = (setShowSystemCheck: any,  setIsModalVisible: any) =>{
    if(deviceCheck()){
        setShowSystemCheck(true);
    }else{
        setIsModalVisible(true);
    }
}


const renderNetworkError =(t: TFunction<"translation", undefined>, handleSubmit: any, handleCancel: any)=>{
      const modalTitles = 
      <div className='landing-page-modal-title'>
            <i className="fa-solid fa-triangle-exclamation icon-warning"></i>
            <p className='modal-warning-message'>{t('LANDING_PAGE_CONNECTION_ERROR')}</p>
      </div>
      
    return (
        <>
            <Modal 
                title={modalTitles}
                open={true} 
                className='modalStyle'
                onOk={handleSubmit}
                onCancel={handleCancel}
                footer={[
                    <ProButton
                        text={t('LANDING_PAGE_TRY_AGAIN')}
                        colorscheme="primary"
                        size="medium"
                        icon=""
                        iconType=""
                        classname="try-again"
                        iconPosition="left"
                        download="none"
                        downloadUrl="#"
                        onClick={(event) => {
                            event.preventDefault();
                            handleSubmit(event);
                        }}
                    />,

                    <ProButton
                        text={t('LANDING_PAGE_CLOSE')}
                        colorscheme="secondary"
                        size="medium"
                        icon=""
                        iconType=""
                        classname="modal-close"
                        iconPosition="left"
                        download="doc"
                        downloadUrl="#"
                        onClick={(event) => {
                            event.preventDefault();
                            handleCancel(event);
                        }}
                    />,
                  ]}
                >    
                <p className='modal-contents'>{t('LANDING_PAGE_CONNECTION_ERROR_MASSEGE')}</p>
            </Modal>
        </>
    )
}

const renderNotScheduled = (
  isEu: boolean,
  t: TFunction<"translation", undefined>,
  setShowSystemCheck: (arg0: boolean) => void,
  setIsModalVisible: (arg0: boolean) => void,
  systemCheckRef: React.LegacyRef<HTMLDivElement> | undefined,
  language: string,
  isFreezeActive: boolean,
  navigate: ReturnType<typeof useNavigate>,
) => {
  const handleOpenSystemCheck = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    if (isFreezeActive) return;
    if (process.env.REACT_APP_ENABLE_IB_DEFAULT_SYSTEM_CHECK === "true") {
      navigate(Locations.systemCheck, {
        state: { isEnableAllSystemCheck: true },
        replace: true,
      });
    } else {
      isDeviceEligible(setShowSystemCheck, setIsModalVisible);
    }
  };

  const renderTextItems = (
    items: {
      key: string;
      url?: string;
      icon?: string;
      iconName?: string;
      iconStyle?: string;
    }[],
  ) => {
    return items.map((item, id) => (
      <li key={id} className="main-text-item">
        {item.icon && (
          <img
            src={item.icon}
            className={item.iconStyle ? item.iconStyle : "main-checkmark-icon"}
            aria-hidden="true"
            alt={item.iconName ? item.iconName : ""}
          />
        )}
        <div className="main-info-text">
          {item.url ? (
            <Trans
              i18nKey={item.key}
              components={[
                <a
                  className="main-text-link"
                  href={item.url}
                  target="_blank"
                />,
              ]}
            ></Trans>
          ) : (
            <Trans i18nKey={item.key}></Trans>
          )}
        </div>
      </li>
    ));
  };

  return (
    <>
      <section id="landing-page-not-scheduled">
        <hr className="landing-page-divider"></hr>
        <h2 className="landing-page-text-label-h2">
          {t("LANDING_PAGE_NOT_SCHEDULED_YET")}
        </h2>
        <div className="landing-page-find-exam">
          {t("LANDING_PAGE_CHECK_YOUR_SYS")}
        </div>
        <div className="landing-page-system-check-group">
          <div className="landing-page-sys-check-button">
            <ProButton
              text={t("LANDING_PAGE_CHECK_SYSTEM")}
              colorscheme="secondary"
              size="medium"
              icon="list-check"
              iconType="fa-solid"
              classname="landing-page-sys-check"
              iconPosition="left"
              download="none"
              downloadUrl="#"
              disabled={isFreezeActive}
              onClick={handleOpenSystemCheck}
            />
          </div>
          <div ref={systemCheckRef} id="landing-page-sys-check-result">
            <p
              role="alert"
              id="landing-page-system-check-result"
              className="landing-page-system-check-result"
            ></p>
            <p
              role="alert"
              id="landing-page-system-check-result-error"
              className="landing-page-system-check-result-error"
            ></p>
          </div>
        </div>
        <div>
          <ul>
            {renderTextItems([
              {
                key: "MAIN_DONT_FORGET_DISABLE_VPNS",
                url: KNOWLEDGE_BASE_URL,
                icon: InfoIcon,
                iconName: "Info icon",
              },
              {
                key: "MAIN_USE_SAME_NETWORK_AS_YOUR_EXAM",
                icon: InfoIcon,
                iconName: "Info icon",
              },
            ])}
          </ul>
        </div>
        {isEu ? (
          <div className="landing-page-find-exam">
            {t("LANDING_PAGE_FOR_MORE_INFO_READ_USER_GUIDE")}
          </div>
        ) : (
          <div className="landing-page-find-exam">
            {t("LANDING_PAGE_FOR_MORE_INFO_READ_USER_GUIDE_AND_VIDEO")}
          </div>
        )}
        <div className="landing-page-user-guide-group">
          <div className="landing-page-user-guide-left">
            <ProButton
              text={t("MAIN_DOWNLOAD_USER_GUIDE")}
              colorscheme="secondary"
              size="medium"
              icon="download"
              iconType="fa-solid"
              classname="landing-page-download"
              iconPosition="left"
              download="doc"
              downloadUrl={getDownloadUserGuideUrl(ENVIRONMENT_NAME!, language)}
              onClick={() => {
                console.log("clicked");
              }}
            />
          </div>
        </div>
        {!isEu && (
          <div className="landing-page-video-section">
            <VideoSection url={process.env.REACT_APP_VIDEO_URL}></VideoSection>
          </div>
        )}
      </section>
    </>
  );
};



export default LandingPage;


